import { Reveal } from "./Reveal";
import { ShieldCheck, Network, Workflow, Headset } from "lucide-react";
import { mediaUrl } from "../lib/api";

const INDICATORS = [
  { icon: ShieldCheck, label: "Seguridad electrónica" },
  { icon: Network, label: "Infraestructura tecnológica" },
  { icon: Workflow, label: "Integración de sistemas" },
  { icon: Headset, label: "Soporte especializado" },
];

export const About = ({ about = {} }) => {
  const title = about.title || "Una empresa tecnológica enfocada en tu seguridad";
  const paragraphs = about.paragraphs || [];

  return (
    <section id="nosotros" data-testid="about-section" className="relative bg-glg-light py-20 sm:py-28 lg:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-2 lg:gap-20">
        <div>
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-glg-blue">Nosotros</p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 max-w-xl font-heading text-3xl font-semibold leading-[1.1] tracking-tight text-glg-black sm:text-4xl lg:text-5xl">
              {title}
            </h2>
          </Reveal>
          {paragraphs.map((p, i) => (
            <Reveal key={i} delay={0.1 + i * 0.05}>
              <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-black/60 sm:text-base">{p}</p>
            </Reveal>
          ))}

          <div className="mt-9 grid grid-cols-2 gap-3">
            {INDICATORS.map((ind, i) => {
              const Icon = ind.icon;
              return (
                <Reveal key={ind.label} delay={0.15 + i * 0.06}>
                  <div className="flex items-center gap-3 rounded-2xl border border-black/5 bg-white p-4 shadow-sm">
                    <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-glg-blue/10">
                      <Icon className="h-5 w-5 text-glg-blue" />
                    </span>
                    <span className="text-sm font-semibold leading-tight text-glg-black">{ind.label}</span>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>

        <Reveal delay={0.1} className="relative">
          <div className="relative aspect-[4/5] overflow-hidden rounded-3xl">
            <img
              src={about.image ? mediaUrl(about.image) : "https://images.unsplash.com/photo-1762163516269-3c143e04175c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"}
              alt="Infraestructura tecnológica GLG Technology"
              loading="lazy"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-glg-black/50 to-transparent" />
          </div>
          <div className="absolute -bottom-5 right-5 hidden rounded-2xl bg-glg-blue px-5 py-4 text-white shadow-xl sm:block">
            <div className="font-heading text-2xl font-bold">Honduras</div>
            <div className="text-xs text-white/80">Cobertura nacional</div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
